import OffersHelper from './offers_helper.js'

class OffersUniqueButtons {

	constructor(router){
		this.router = router
		this.offers_helper = new OffersHelper()
	}

	getUniqueButtons(){
		return [
		  {
		    name: 'past',
		    display_text: 'PAST',
		    css_classes: {
		      'is-info': () => this.router.app.$route.query.past
		    }
		  },
		  {
		    name: 'future',
		    display_text: 'FUTURE',
		    css_classes: {
		      'is-info': () => this.router.app.$route.query.future
		    }
		  },
		  {
		    name: 'faded_border_split',
		    css_classes: {
		      'unique_button_right_split': () => true,
		    }
		  },
		  {
		    name: 'orange',
		    display_text: 'Orange',
		    css_classes: {
		      'is-orange': () => this.getGroupStatuses('Orange').join(',') == this.router.app.$route.query.statuses
		    }
		  },
		  {
		    name: 'red',
		    display_text: 'Red',
		    css_classes: {
		    'is-red': () => this.getGroupStatuses('Red').join(',') ==  this.router.app.$route.query.statuses 
		    }
		  },
		  {
		    name: 'green',
		    display_text: 'Green',
		    css_classes: {
		      'is-green': () => this.getGroupStatuses('Green').join(',') ==  this.router.app.$route.query.statuses 
		    }
		  }
		]
	}

	getGroupStatuses(group){
		return this.offers_helper[`get${group}Statuses`]()
	}

	selectStatusGroup(group){
		let query = {...this.router.app.$route.query}
		query.statuses = this.getGroupStatuses(group).join(',')
		this.router.push({ name: this.router.app.$route.name, query })
	}

    toggleQueryParam (param_name) {
      let query = { ...this.router.app.$route.query }
      let query_param = query[param_name]
      let new_param = ''
      if (query_param == undefined || query_param.toString() == 'false') {
        new_param = true
      }
      if (query_param != undefined && query_param.toString() == 'true') {
        new_param = undefined
      }
      query[param_name] = new_param
      this.router.push({ name: this.router.app.$route.name, query })
    }

}

export default OffersUniqueButtons